export interface Job {
  id: string;
  title: string;
  company: string;
  location: string;
  state: string;
  type: "FIFO" | "Residential" | "Remote";
  mineral: "Gold" | "Copper" | "Coal" | "Iron Ore" | "General";
  salary: string;
  salaryNum: number;
  experience: "Entry Level" | "Mid Level" | "Senior" | "Supervisor";
  posted: string;
  tags: string[];
  featured: boolean;
  logo: string;
  description: string;
}

export const jobs: Job[] = [
  {
    id: "j001",
    title: "Surface Drill Operator",
    company: "Newcrest Mining",
    location: "Kalgoorlie, WA",
    state: "WA",
    type: "FIFO",
    mineral: "Gold",
    salary: "$95,000 – $115,000",
    salaryNum: 105000,
    experience: "Mid Level",
    posted: "2 days ago",
    tags: ["FIFO", "Gold", "Drill & Blast", "WA"],
    featured: true,
    logo: "NC",
    description: "Operate surface drilling equipment at our flagship Cadia Valley gold operation on a 8/6 FIFO roster.",
  },
  {
    id: "j002",
    title: "Mine Truck Driver – No Experience",
    company: "BHP Minerals",
    location: "Port Hedland, WA",
    state: "WA",
    type: "FIFO",
    mineral: "Iron Ore",
    salary: "$80,000 – $95,000",
    salaryNum: 87500,
    experience: "Entry Level",
    posted: "1 day ago",
    tags: ["Entry Level", "Iron Ore", "Haul Truck", "FIFO"],
    featured: true,
    logo: "BH",
    description: "No mining experience required. Full training provided. Join BHP's Pilbara iron ore operations on a 2/1 FIFO roster.",
  },
  {
    id: "j003",
    title: "Exploration Geologist",
    company: "OZ Minerals",
    location: "Olympic Dam, SA",
    state: "SA",
    type: "FIFO",
    mineral: "Copper",
    salary: "$110,000 – $135,000",
    salaryNum: 122500,
    experience: "Mid Level",
    posted: "3 days ago",
    tags: ["Geology", "Copper", "Exploration", "FIFO"],
    featured: false,
    logo: "OZ",
    description: "Lead exploration programs at our Olympic Dam copper-uranium operation in South Australia.",
  },
  {
    id: "j004",
    title: "Underground Miner – Trainee",
    company: "Evolution Mining",
    location: "Cobar, NSW",
    state: "NSW",
    type: "Residential",
    mineral: "Gold",
    salary: "$75,000 – $88,000",
    salaryNum: 81500,
    experience: "Entry Level",
    posted: "Today",
    tags: ["Entry Level", "Underground", "Trainee", "Gold"],
    featured: false,
    logo: "EV",
    description: "Entry-level underground mining traineeship. Full cert II & III training pathway. No previous mining experience needed.",
  },
  {
    id: "j005",
    title: "Coal Mine Operator",
    company: "Glencore Coal",
    location: "Bowen Basin, QLD",
    state: "QLD",
    type: "FIFO",
    mineral: "Coal",
    salary: "$105,000 – $125,000",
    salaryNum: 115000,
    experience: "Mid Level",
    posted: "4 days ago",
    tags: ["Coal", "FIFO", "QLD", "Operator"],
    featured: false,
    logo: "GL",
    description: "Operate heavy mining equipment including draglines and excavators at our Bowen Basin coking coal operations.",
  },
  {
    id: "j006",
    title: "Mine Site Electrician",
    company: "Rio Tinto",
    location: "Tom Price, WA",
    state: "WA",
    type: "FIFO",
    mineral: "Iron Ore",
    salary: "$120,000 – $145,000",
    salaryNum: 132500,
    experience: "Mid Level",
    posted: "5 days ago",
    tags: ["Electrician", "Iron Ore", "FIFO", "Trade"],
    featured: false,
    logo: "RT",
    description: "Trade-qualified electricians required for Rio Tinto's Pilbara iron ore network. 8/6 FIFO from Perth.",
  },
  {
    id: "j007",
    title: "Safety Officer – Entry Level",
    company: "Sandfire Resources",
    location: "DeGrussa, WA",
    state: "WA",
    type: "FIFO",
    mineral: "Copper",
    salary: "$85,000 – $98,000",
    salaryNum: 91500,
    experience: "Entry Level",
    posted: "1 week ago",
    tags: ["Safety", "Copper", "Entry Level", "FIFO"],
    featured: false,
    logo: "SF",
    description: "Graduate/entry-level safety officer role at our DeGrussa copper-gold mine. Cert IV WHS preferred but not essential.",
  },
  {
    id: "j008",
    title: "Processing Plant Operator",
    company: "Northern Star Resources",
    location: "Jundee, WA",
    state: "WA",
    type: "FIFO",
    mineral: "Gold",
    salary: "$90,000 – $108,000",
    salaryNum: 99000,
    experience: "Mid Level",
    posted: "2 days ago",
    tags: ["Gold", "Processing", "Plant", "FIFO"],
    featured: true,
    logo: "NS",
    description: "Operate and maintain gold processing plant circuits at Jundee. Experience with carbon-in-leach (CIL) preferred.",
  },
];

export const mineralCategories = [
  {
    name: "Gold",
    color: "#f59e0b",
    bgColor: "rgba(245,158,11,0.1)",
    borderColor: "rgba(245,158,11,0.2)",
    count: jobs.filter((j) => j.mineral === "Gold").length,
    icon: "🥇",
    avgSalary: "$95K–$135K",
  },
  {
    name: "Copper",
    color: "#b45309",
    bgColor: "rgba(180,83,9,0.1)",
    borderColor: "rgba(180,83,9,0.2)",
    count: jobs.filter((j) => j.mineral === "Copper").length,
    icon: "🔶",
    avgSalary: "$90K–$130K",
  },
  {
    name: "Coal",
    color: "#9ca3af",
    bgColor: "rgba(156,163,175,0.1)",
    borderColor: "rgba(156,163,175,0.2)",
    count: jobs.filter((j) => j.mineral === "Coal").length,
    icon: "⚫",
    avgSalary: "$100K–$125K",
  },
  {
    name: "Iron Ore",
    color: "#dc2626",
    bgColor: "rgba(220,38,38,0.1)",
    borderColor: "rgba(220,38,38,0.2)",
    count: jobs.filter((j) => j.mineral === "Iron Ore").length,
    icon: "🔴",
    avgSalary: "$85K–$145K",
  },
];

export const seoKeywords = [
  { keyword: "FIFO mine jobs", volume: 12400, difficulty: 38, cpc: 4.20, intent: "Transactional", trend: "+18%" },
  { keyword: "entry level mining jobs", volume: 9800, difficulty: 31, cpc: 3.80, intent: "Transactional", trend: "+24%" },
  { keyword: "mineral careers", volume: 6200, difficulty: 28, cpc: 2.90, intent: "Informational", trend: "+9%" },
  { keyword: "inexperienced mining roles", volume: 4500, difficulty: 22, cpc: 3.10, intent: "Transactional", trend: "+31%" },
  { keyword: "mining jobs no experience", volume: 8900, difficulty: 29, cpc: 3.50, intent: "Transactional", trend: "+27%" },
  { keyword: "gold mine jobs Australia", volume: 5600, difficulty: 41, cpc: 4.80, intent: "Transactional", trend: "+12%" },
  { keyword: "copper mining careers", volume: 3200, difficulty: 33, cpc: 3.20, intent: "Informational", trend: "+7%" },
  { keyword: "coal mining jobs QLD", volume: 7100, difficulty: 35, cpc: 3.90, intent: "Transactional", trend: "-3%" },
  { keyword: "iron ore jobs Pilbara", volume: 4800, difficulty: 39, cpc: 4.10, intent: "Transactional", trend: "+15%" },
  { keyword: "mining trainee positions", volume: 3900, difficulty: 26, cpc: 2.70, intent: "Transactional", trend: "+22%" },
  { keyword: "underground miner salary", volume: 6700, difficulty: 24, cpc: 1.80, intent: "Informational", trend: "+8%" },
  { keyword: "FIFO roster mining", volume: 5100, difficulty: 30, cpc: 2.50, intent: "Informational", trend: "+11%" },
];
